import React, { useEffect, useState, useRef } from "react"
import {
  Row,
  Col,
  Container,
  InputGroup,
  Button,
  Input,
  UncontrolledTooltip
} from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import "../../assets/scss/order.scss"
import withRouter from "components/Common/withRouter"
import TrackOrder from "./trackOrderModal"
import OrderContainer from "./Delaer-order.component"
import Feedback from "./feedbackModal"
import ProductReview from "./reviewModal"
import moment from 'moment-timezone';

import {
  getConfirmOrderList,
  getTrackingDetailsList,
} from "http/order/order"
import ToastDialog from "components/Common/ToastDialog"
import Pagination from "./Pagination"
import CustomLoader from "components/CustomLoader"
import Flatpickr from "react-flatpickr";
import { useNavigate } from "react-router-dom"
import { getAllRegions } from "helpers/UAM/region.helper"

const DealerOrderList2 = () => {
  //meta title
  document.title = "My Orders | DMS"
  const navigate = useNavigate()
  const [filters, setFilters] = useState({});
  const userData = JSON.parse(localStorage.getItem("user"))
  const [modal1, setModal1] = useState(false)
  const [modal2, setModal2] = useState(false)
  const [modal3, setModal3] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [orderId, setOrderId] = useState(null)
  const [orderList, setOrderList] = useState([])
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const [loading, setLoading] = useState(false)
  const [pageSize, setPageSize] = useState(50)
  const [searchKey, setSearchKey] = useState("")
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  })
  const [trackingUrl, setTrackingUrl] = useState({})
  const flatpickrRef = useRef(null);


  const urlParams = new URLSearchParams(window.location.search);
  const orderCode = urlParams.get('orderCode');
  const [orderReasonOptions, setOrderReasonOptions] = useState([])

  useEffect(() => {
    if (orderCode) {
      handleSearch(orderCode)
    } else {
      setSearchKey('')
      getOrderListByStatus({ limit: pageSize })
    }
    fetchTrackingDetails()
    fetchOrderReason()
  }, [orderCode])

  const toggleViewModal = value => {
    setModal1(!modal1)
  }
  const toggleViewModalForFeedback = () => setModal2(!modal2)
  const toggleModalForReview = () => setModal3(!modal3)

  const handleChangeOrderId = id => {
    setOrderId(id)
  }

  const getOrderListByStatus = (data = {}) => {
    if (orderList?.length == 0) {
      setLoading(true)
    }
    data.userId = userData.id
    data.isSearch = true
    getConfirmOrderList(data)
      .then(responseFromApi => {
        if (responseFromApi.status && responseFromApi.code == 200) {
          setOrderList(responseFromApi.data.data)
          const { totalItems, totalPages, currentPage } = responseFromApi.data
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          })
        } else {
          setOrderList([])
          setPagination({
            pageIndex: 0,
            pageCount: 0,
            totalRecords: 0,
          })
        }
        setTimeout(() => {
          setLoading(false)
        }, 500)
      })
      .catch(error => {
        setTimeout(() => {
          setLoading(false)
        }, 500)
      })
  }

  const handleCancel = id => {
    setOrderId(id)
    setCancelModal(true)
  }

  const handlePageChange = (page, pageS) => {
    getOrderListByStatus({ page, limit: pageSize, searchKey, orderStatus: "all", filterType: filters })
  }

  const handleClearSearch = () => {
    setSearchKey("")
    setFilters({})
    flatpickrRef.current.flatpickr.clear();

    getOrderListByStatus({ page: 1, limit: pageSize, searchKey: "", orderStatus: "all", filterType: {} })
  }

  const handleSearch = (searchKey) => {
    setSearchKey(searchKey)
    getOrderListByStatus({ page: 1, limit: pageSize, searchKey, orderStatus: "all", filterType: filters })
  }

  const handleDateFilter = () => {
    getOrderListByStatus({
      page: 1, limit: pageSize, searchKey, orderStatus: "all", filterType: filters
    })
  }

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      setFilters({
        ...filters,
        startDate: selectedDates[0],
        endDate: selectedDates[1],
      })
    }
  };

  const fetchTrackingDetails = async () => {
    try {
      let res = await getTrackingDetailsList()
      if (res.status) {
        const trackingDetailsData = res.data
        const initialTrackingUrls = trackingDetailsData?.reduce((acc, data) => {
          acc[data.orderId] = data.trackingDetails
          return acc
        }, {})
        setTrackingUrl(initialTrackingUrls)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const fetchOrderReason = async () => {
    try {
      let res = await getAllRegions({ dropdownName: 'order_reasons' })
      if (res.status) {
        setOrderReasonOptions(
          res?.data?.regions[0]?.dropdownValues?.map(i => ({
            label: `${i.displayName} (${i.dropdownValue})`,
            value: i.dropdownValue,
          }))
        )
      } else {
        setOrderReasonOptions([])
      }
    } catch (error) {
      setOrderReasonOptions([])
    }
  }

  return (
    <React.Fragment>
      {orderId && (
        <TrackOrder
          isOpen={modal1}
          toggle={toggleViewModal}
          orderId={orderId}
        />
      )}
      <Feedback isOpen={modal2} toggle={toggleViewModalForFeedback} />
      <ProductReview isOpen={modal3} toggle={toggleModalForReview} />
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12} sm={12} xl={12} className="page-title-box d-flex gap-3 justify-content-between align-items-center" style={{ paddingBottom: "0" }}>
              <div className="d-flex align-items-center ">
                <h4 className="mb-sm-0 font-size-18">
                  Orders
                </h4>
              </div>
              <div>
                <button
                  className="btn btn-outline-secondary ms-2"
                  type="button"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </button>
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col lg={12}>
              {!loading ? (
                <Row>
                  <Col sm="12">
                    <div className="page-title-box">
                      <div className="row align-items-center gap-2 gap-md-0">
                        <div className="col-md-3">
                          <Input
                            name="natureOfBusiness"
                            type="select"
                            onChange={(e) => {
                              setPageSize(e.target.value)
                              getOrderListByStatus({ page: 1, limit: e.target.value, searchKey, orderStatus: "all", filterType: filters })

                            }}
                            value={pageSize || ""}
                          >
                            <option value="10">Show 10</option>
                            <option value="50">Show 50</option>
                            <option value="100">Show 100</option>
                            <option value="200">Show 200</option>
                          </Input>
                        </div>
                        <div className="col-md-3">
                          <InputGroup>
                            <Flatpickr
                              ref={flatpickrRef}
                              className="form-control"
                              placeholder="Start Date - End Date"
                              options={{
                                mode: 'range',
                                dateFormat: 'd-m-Y'
                              }}
                              value={filters?.startDate && filters?.endDate ? [filters?.startDate, filters?.endDate] : []}
                              onChange={handleDateChange}
                            />
                            <Button variant="primary"
                              onClick={handleDateFilter}
                              style={{ backgroundColor: "#344fa0", border: "none" }}>
                              Go
                            </Button>
                          </InputGroup>
                        </div>
                        <div className="col-md-4">
                          <div className="search-box me-xxl-2 my-0 my-xxl-0 d-flex align-items-center justify-content-start">
                            <div className="position-relative me-md-3">
                              <label htmlFor="search-bar-0" className="search-label mb-0">
                                <input
                                  value={searchKey}
                                  onChange={e => handleSearch(e.target.value)}
                                  id="search-bar-0"
                                  type="text"
                                  className="form-control"
                                  placeholder={`${pagination.totalRecords} records...`}
                                />
                              </label>
                              <UncontrolledTooltip
                                placement="bottom"
                                target="search-bar-0"
                                trigger="hover"
                              >
                                Search by Order Id, Order Request Id, SAP Order Id
                              </UncontrolledTooltip>
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                            <Button
                              type="button"
                              outline
                              color="success"
                              className="btn-rounded  me-2 mt-2 mt-md-0"
                              onClick={() => {
                                handleClearSearch()
                                // setValue("")
                              }}
                            >
                              {" "}
                              Clear
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm="12" className="mt-2">
                    {orderList.length > 0 ? (
                      <OrderContainer
                        orderList={orderList}
                        orderReasonOptions={orderReasonOptions}
                        toggleModal={toggleViewModal}
                        toggleViewModalForFeedback={toggleViewModalForFeedback}
                        toggleModalForReview={toggleModalForReview}
                        handleChangeOrderId={handleChangeOrderId}
                        handleCancel={handleCancel}
                        trackingUrl={trackingUrl}
                      />
                    ) : (
                      <p
                        className="text-center text-success  fs-3 fw-bold"
                        style={{ marginTop: "10rem" }}
                      >
                        No order Found!!
                      </p>
                    )}
                  </Col>
                </Row>
              ) : (
                <div
                  style={{
                    height: "70vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <CustomLoader />
                  <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <p style={{ color: "#9b9b9b" }}>
                      Please wait while we fetch orders.
                    </p>
                  </div>
                </div>
              )}
            </Col>
          </Row>

          {!loading && pagination.pageCount != 0 && (
            <div style={{ marginLeft: "300px", marginBottom: "25px" }}>
              <Pagination
                pagination={pagination}
                handlePageChange={handlePageChange}
              />
            </div>
          )}
        </Container>
      </div>

      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

export default withRouter(DealerOrderList2)
